import { render, staticRenderFns } from "./ContentReferenzen.vue?vue&type=template&id=3ffe18b0&"
import script from "./ContentReferenzen.vue?vue&type=script&lang=js&"
export * from "./ContentReferenzen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports